import { useSelector } from "react-redux"
import { nameForKey } from "reduxSlices/customNamesSlice"
import { customNameForms } from "utils/customNameHelpers"

// The forms a renameable thing is read in, for the name the organization has set or
// the default for a key it has not renamed.  Anything displaying one of these names
// reads it from here rather than hard-coding "Facility" or "Department", so that the
// four forms stay consistent wherever the name appears.
const useCustomName = (key) => customNameForms(useSelector(nameForKey(key)))

export default useCustomName
